import { render, staticRenderFns } from "./ItemsPerPageDropdown.vue?vue&type=template&id=379eb804&scoped=true&"
import script from "./ItemsPerPageDropdown.vue?vue&type=script&lang=js&"
export * from "./ItemsPerPageDropdown.vue?vue&type=script&lang=js&"
import style0 from "./custom-grid.css?vue&type=style&index=0&id=379eb804&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379eb804",
  null
  
)

export default component.exports